import { higginsColors } from '@higgins/ui';
import type { CardItem } from '@/lib/types';

interface CardVisualProps {
  data: CardItem[];
}

export function CardVisual({ data }: CardVisualProps) {
  const colClass =
    data.length <= 2 ? 'grid-cols-2' :
    data.length <= 3 ? 'grid-cols-3' :
    data.length <= 4 ? 'grid-cols-2 grid-rows-2' :
    'grid-cols-3';

  return (
    <div className={`grid ${colClass} gap-3 h-full p-2`}>
      {data.map((item, i) => (
        <div
          key={i}
          className="flex flex-col items-center justify-center rounded-lg border border-border bg-card p-3 text-center gap-1"
        >
          <span
            className="text-2xl font-bold tabular-nums"
            style={{ color: higginsColors[i % higginsColors.length] }}
          >
            {String(item.value)}
          </span>
          <span className="text-xs font-medium text-foreground">{item.label}</span>
          {item.subLabel && (
            <span className="text-xs text-muted-foreground">{item.subLabel}</span>
          )}
        </div>
      ))}
    </div>
  );
}
